<template>
  <div>
    <div v-if="isMobileOrTablet">
      <appHeader :searchFilter="searchFilter"></appHeader>
      <transition appear name="fade">
        <div class="container-fluid px-2 pt-2 shop pb-4">
          <div class="row pb-5 d-flex justify-content-center">
            <div class="col-md-12 product-grid row">
              <div class="col-md-6 filters-row pl-xs-2 pl-sm-0">
                <div class="form-group">
                  <appBreadcrumb :currentCategoryId="currentCategoryId"></appBreadcrumb>
                  <!-- MOBILE FILTERS — compact chip row -->
                  <div class="mobile-filter-bar mt-2 mb-2">
                    <!-- Per Page chip -->
                    <div class="mf-chip">
                      <span class="mf-chip__label">Per Page</span>
                      <span class="mf-chip__divider"></span>
                      <select v-model="selectedLimitFilterValue" class="mf-chip__select" @change="limitFilterChange()">
                        <option v-for="limits in perPageLimits" :key="limits.id" :value="limits.id">{{ limits.name }}</option>
                      </select>
                    </div>

                    <!-- Points filter chip -->
                    <div v-if="shouldShowFilters" class="mf-chip">
                      <span class="mf-chip__label">Points</span>
                      <span class="mf-chip__divider"></span>
                      <select v-model="selectedPointFilter" class="mf-chip__select" @change="pointFilterChange()">
                        <option v-for="point in pointFilters" :key="point.id" :value="point.id">{{ point.name }}</option>
                      </select>
                    </div>

                    <!-- Sort chip -->
                    <div class="mf-chip">
                      <span class="mf-chip__label">Sort</span>
                      <span class="mf-chip__divider"></span>
                      <select v-model="selectedSort" class="mf-chip__select">
                        <option v-for="sort in sortOrders" :value="sort.id" :key="sort.id">{{ sort.name }}</option>
                      </select>
                    </div>

                  </div>

                  <!-- Custom Range — shown inline below chips when needed -->
                  <div v-if="shouldShowFilters && selectedPointFilter === 'custom'" class="mobile-custom-range mb-2">
                    <input type="number" min="0" class="mcr-input" v-model="minFilterPoint" placeholder="Min pts" />
                    <span class="mcr-sep">–</span>
                    <input type="number" min="0" class="mcr-input" v-model="maxFilterPoint" placeholder="Max pts" />
                  </div>
                </div>
              </div>

              <appProductGrid
                v-if="allowProductGrid"
                :searchFilter="searchFilter"
                :pointFilter="pointFilterValue"
                :limitFilter="limitFilterValue"
                :sortOrder="selectedSort"
              ></appProductGrid>
            </div>
          </div>
        </div>
      </transition>

      <div class="bottom-container" v-if="exclusiveCategories.length > 0">
        <div class="w-50">
          <router-link v-if="isTravelConciergeEnabled" to="/services">
            <button class="w-100 h-100 buttons">Services</button>
          </router-link>
          <router-link v-if="isTicketAndExperiencesEnabled" to="/tickets-and-experiences">
            <button class="w-100 h-100 buttons">Tickets &amp; Experiences</button>
          </router-link>
        </div>
        <div class="w-50">
          <router-link to="/filter">
            <button class="w-100 h-100 buttons">Category</button>
          </router-link>
        </div>
      </div>
      <div v-else class="bottom-container">
        <router-link to="/filter" class="w-100">
          <button class="w-100 h-100 buttons">Category</button>
        </router-link>
      </div>
      <navigationFooter></navigationFooter>
    </div>

    <!-- ===== DESKTOP ===== -->
    <div v-else class="pt-4 desktop-shell">
      <appHeader :searchFilter="searchFilter"></appHeader>
      <transition appear name="fade">
        <div class="container-fluid px-4 shop">

          <!-- Curated nav bar -->
          <!-- Curated nav bar -->
          <div class="row pb-2" v-if="curatedItems.length > 0">
            <div class="col-md-12">
              <nav
                class="curated-nav"
                :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }"
              >
                <!-- dark overlay strip for readability -->
                <div class="curated-nav__inner">
                  <ul class="curated-list">
                    <li v-for="item in curatedItems" :key="item.id">
                      <a
                        href="javascript:void(0)"
                        class="curated-tab"
                        :class="{ 'curated-tab--active': activeCuratedId === item.id }"
                        @click="activeCuratedId = item.id; $router.push({ path: '/curated-items', query: { id: item.id } })"
                      >
                        {{ item.title }}
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>

          <!-- Catalog grids -->
          <div class="row mb-3" v-if="catalogGrids.length > 0 && catalogGrids[0].grid_items.length == 1">
            <div class="col-md-12">
              <div class="catalog-grid-wrapper">

                <!-- Grid 0 — 1 item (full height image) -->
                <div class="catalog-card" :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }">
                  <div class="catalog-card__header">
                    <h6 class="catalog-card__title">{{ catalogGrids[0].title }}</h6>
                  </div>
                  <a :href="catalogGrids[0].grid_items[0].redirectionData" class="catalog-item catalog-item--single">
                    <div class="catalog-img-wrap catalog-img-wrap--tall">
                      <img :src="catalogGrids[0].grid_items[0].image_url" alt="" />
                    </div>
                    <p class="catalog-item__label">{{ catalogGrids[0].grid_items[0].title }}</p>
                  </a>
                </div>

                <!-- Grid 1 — 4 items (2×2) -->
                <div class="catalog-card" v-if="catalogGrids.length > 1 && catalogGrids[1].grid_items.length == 4" :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }">
                  <div class="catalog-card__header">
                    <h6 class="catalog-card__title">{{ catalogGrids[1].title }}</h6>
                  </div>
                  <div class="catalog-grid-2x2">
                    <a v-for="n in 4" :key="n" :href="catalogGrids[1].grid_items[n-1].redirectionData" class="catalog-item">
                      <div class="catalog-img-wrap">
                        <img :src="catalogGrids[1].grid_items[n-1].image_url" alt="" />
                      </div>
                      <p class="catalog-item__label">{{ catalogGrids[1].grid_items[n-1].title }}</p>
                    </a>
                  </div>
                </div>

                <!-- Grid 2 — 3 items (2 top + 1 wide bottom) -->
                <div class="catalog-card" v-if="catalogGrids.length > 2 && catalogGrids[2].grid_items.length == 3" :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }">
                  <div class="catalog-card__header">
                    <h6 class="catalog-card__title">{{ catalogGrids[2].title }}</h6>
                  </div>
                  <div class="catalog-grid-top2-bot1">
                    <a :href="catalogGrids[2].grid_items[0].redirectionData" class="catalog-item">
                      <div class="catalog-img-wrap">
                        <img :src="catalogGrids[2].grid_items[0].image_url" alt="" />
                      </div>
                      <p class="catalog-item__label">{{ catalogGrids[2].grid_items[0].title }}</p>
                    </a>
                    <a :href="catalogGrids[2].grid_items[1].redirectionData" class="catalog-item">
                      <div class="catalog-img-wrap">
                        <img :src="catalogGrids[2].grid_items[1].image_url" alt="" />
                      </div>
                      <p class="catalog-item__label">{{ catalogGrids[2].grid_items[1].title }}</p>
                    </a>
                    <a :href="catalogGrids[2].grid_items[2].redirectionData" class="catalog-item catalog-item--wide">
                      <div class="catalog-img-wrap catalog-img-wrap--wide">
                        <img :src="catalogGrids[2].grid_items[2].image_url" alt="" />
                      </div>
                      <p class="catalog-item__label">{{ catalogGrids[2].grid_items[2].title }}</p>
                    </a>
                  </div>
                </div>

                <!-- Grid 3 — 4 items (2×2) -->
                <div class="catalog-card" v-if="catalogGrids.length > 3 && catalogGrids[3].grid_items.length == 4" :style="{ background: bgColorCode ? (bgColorCode.startsWith('#') ? bgColorCode : '#' + bgColorCode) : '#312589' }">
                  <div class="catalog-card__header">
                    <h6 class="catalog-card__title">{{ catalogGrids[3].title }}</h6>
                  </div>
                  <div class="catalog-grid-2x2">
                    <a v-for="n in 4" :key="n" :href="catalogGrids[3].grid_items[n-1].redirectionData" class="catalog-item">
                      <div class="catalog-img-wrap">
                        <img :src="catalogGrids[3].grid_items[n-1].image_url" alt="" />
                      </div>
                      <p class="catalog-item__label">{{ catalogGrids[3].grid_items[n-1].title }}</p>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Main shop area -->
          <div class="row pt-3">
            <div class="col-md-3 col-sm-12 d-none d-sm-block sidebar">
              <appProductSidebar></appProductSidebar>
            </div>
            <div class="col-md-9 product-grid row pl-3">
              <!-- Filter bar -->
              <div class="col-12 desktop-filter-bar mb-3">
                <div class="filter-bar-inner">
                  <div class="filter-bar__breadcrumb">
                    <appBreadcrumb :currentCategoryId="currentCategoryId"></appBreadcrumb>
                  </div>
                  <div class="filter-bar__controls">
                    <div class="filter-control">
                      <label>Per page</label>
                      <select v-model="selectedLimitFilterValue" @change="limitFilterChange()">
                        <option v-for="limits in perPageLimits" :value="limits.id" :key="limits.id">
                          {{ limits.name }}
                        </option>
                      </select>
                    </div>

                    <div v-if="shouldShowFilters" class="filter-control">
                      <label>Filter by points</label>
                      <select v-model="selectedPointFilter" @change="pointFilterChange()">
                        <option v-for="point in pointFilters" :value="point.id" :key="point.id">
                          {{ point.name }}
                        </option>
                      </select>
                    </div>

                    <div v-if="shouldShowFilters && selectedPointFilter == 'custom'" class="filter-control filter-control--range">
                      <input type="number" min="0" v-model="minFilterPoint" placeholder="Min" />
                      <span class="range-sep">–</span>
                      <input type="number" min="0" v-model="maxFilterPoint" placeholder="Max" />
                      <button class="apply-btn" type="button" @click="filterProducts()">Apply</button>
                    </div>

                    <div class="filter-control">
                      <label>Sort by</label>
                      <select v-model="selectedSort">
                        <option v-for="sort in sortOrders" :value="sort.id" :key="sort.id">
                          {{ sort.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <appProductGrid
                :searchFilter="searchFilter"
                :sortOrder="selectedSort"
                :pointFilter="pointFilterValue"
                :limitFilter="limitFilterValue"
              ></appProductGrid>
            </div>
          </div>
        </div>
      </transition>
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ProductGrid from "./ProductGrid.vue";
import ProductSidebar from "./ProductSidebar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import navigationFooter from "../../components/navigationFooter.vue";
import { isMobile, isTablet } from "mobile-device-detect";
import { mapState } from "vuex";
import FrontendService from "../../services/FrontendService"

export default {
  props: {
    initialCurrentCategoryId: Number,
    clearSearch: Boolean,
  },
  watch: {
    initialCurrentCategoryId: function (newValue, oldValue) {
      this.$store.dispatch("category/setCurrentCategoryId", newValue);
    },
  },
  data() {
    return {
      selectedSort: "new.desc",
      selectedPointFilter:"",
      pointFilterValue: "",
      limitFilterValue: 20,
      allowProductGrid: false,
      selectedLimitFilterValue: 20,
      sortOrders: [
        { id: "price.desc", name: "Price high to low" },
        { id: "price.asc", name: "Price low to high" },
        { id: "new.desc", name: "Newest first" },
        { id: "new.asc", name: "Oldest first" },
        { id: "alphabet.asc", name: "A - Z" },
        { id: "alphabet.desc", name: "Z - A" },
      ],
      pointFilters: [
        { id: "", name: "All" },
        { id: "1-1000", name: "1-1,000 Points" },
        { id: "1001-2500", name: "1,001-2,500 Points" },
        { id: "2501-5000", name: "2,501-5,000 Points" },
        { id: "5001-8000", name: "5,001-8,000 Points" },
        { id: "8001-10000", name: "8,001-10,000 Points" },
        { id: "custom", name: "Custom" },
      ],
      perPageLimits: [
        { id: 20, name: "20 Items" },
        { id: 40, name: "40 Items" },
        { id: 60, name: "60 Items" },
        { id: 80, name: "80 Items" },
        { id: 100, name: "100 Items" },
      ],
      minFilterPoint: "",
      maxFilterPoint: "",
      catalogGrids: [],
      activeCuratedId: null,
      curatedItems: [],
      bgColorCode: "#FF0000",
      isLoadingMinMax: true,
    };
  },
  computed: {
    ...mapState({
      currentCategoryId: (state) => state.category.currentCategoryId,
      exclusiveCategories: (state) => state.category.exclusives,
    }),
    shouldShowFilters() {
      if (this.isLoadingMinMax) return false;
      return Number(this.maxFilterPoint) === 0;
    },
    isTravelConciergeEnabled: function () {
      return this.exclusiveCategories.filter((item) => item["type"] === "CONCIERGE").length > 0;
    },
    isTicketAndExperiencesEnabled: function () {
      return this.exclusiveCategories.filter((item) => item["type"] === "TICKETSANDEXPERIENCES").length > 0;
    },
    searchFilter: function () {
      if (this.$route.query.clearSearch) return undefined;
      return this.$route.query.search;
    },
    isMobileOrTablet: function () {
      return isMobile || isTablet;
    },
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appProductGrid: ProductGrid,
    appProductSidebar: ProductSidebar,
    appBreadcrumb: Breadcrumb,
    navigationFooter: navigationFooter,
  },
  methods: {
    getCatalogGridsForUser() {
      FrontendService.getCatalogGridsForUser({}).then((response) => {
        console.log('[CatalogGrids] raw response.data:', response.status, JSON.stringify(response.data));
        if (response.status === 200) {
          this.catalogGrids = response.data.grids || [];
          this.bgColorCode = response.data.customize_grid_layout_bg_color;
          console.log('[CatalogGrids] assigned catalogGrids:', this.catalogGrids);
        }
      }).catch((e) => { console.error('[CatalogGrids] error', e); alert(e.response.data.message); });
    },
    getCuratedItems() {
      FrontendService.getCuratedItems({}).then((response) => {
        if (response.status === 200) this.curatedItems = response.data || [];
      }).catch((e) => { alert(e.response.data.message); });
    },
    pointFilterChange() {
      if (this.selectedPointFilter !== "custom") {
        this.pointFilterValue = this.selectedPointFilter || "";
      }
    },
    limitFilterChange() {
      this.limitFilterValue = this.selectedLimitFilterValue;
    },
    filterProducts() {
      if (!this.minFilterPoint || !this.maxFilterPoint) {
        alert("Please enter min and max point to filter");
        return;
      }
      this.pointFilterValue = this.minFilterPoint + "-" + this.maxFilterPoint;
    },
    async loadMinMaxAndApplyFilter() {
      this.isLoadingMinMax = true;
      try {
        const response = await FrontendService.getMinMaxPoints({});
        if (response.status === 200) {
          this.minFilterPoint = Number(response.data.minpointvalue);
          this.maxFilterPoint = Number(response.data.maxpointvalue);
          if (this.maxFilterPoint !== 0) {
            this.pointFilterValue = `${this.minFilterPoint}-${this.maxFilterPoint}`;
          } else {
            this.pointFilterValue = "";
          }
          this.allowProductGrid = true;
        }
      } catch (e) {
        console.error("MINMAX error", e);
      } finally {
        this.isLoadingMinMax = false;
      }
    },
    async initializeMinMax() {
      await this.loadMinMaxAndApplyFilter();
    },
  },
  created() {
    if (!this.initialCurrentCategoryId) {
      this.$store.dispatch("category/fetchRootCategory");
    } else {
      this.$store.dispatch("category/setCurrentCategoryId", this.initialCurrentCategoryId);
    }
    this.$store.dispatch("category/fetchExclusives");
    this.getCatalogGridsForUser();
    this.getCuratedItems();
    this.initializeMinMax();
  },
};
</script>

<style lang="scss" scoped>
/* ─── FADE TRANSITION ─────────────────────────────────── */
.fade-enter-active { transition: opacity 0.4s ease; }
.fade-enter       { opacity: 0; }

/* ─── DESKTOP SHELL ───────────────────────────────────── */
.desktop-shell {
  background: #f7f8fc;
  min-height: 100vh;
}

/* ─── CURATED NAV ─────────────────────────────────────── */
.curated-nav {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 4px;
  /* dynamic bg color applied via :style binding */
}

/* Dark semi-transparent overlay — ensures tabs are always readable
   regardless of what the dynamic brand color is */
.curated-nav__inner {
  background: rgba(0, 0, 0, 0.28);
  padding: 10px 14px;
  display: flex;
  align-items: center;
}

.curated-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.curated-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 22px;
  /* solid white text — always readable on any dark bg */
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-decoration: none;
  border-radius: 50px;
  /* visible opaque border + subtle frosted bg */
  border: 2px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
  /* slight text shadow for legibility on light brand colors */
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);

  &:hover {
    background: rgba(255, 255, 255, 0.28);
    border-color: #fff;
    color: #fff;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
  }

  /* Active tab: solid white pill, colored text — maximum contrast */
  &--active {
    background: #ffffff;
    border-color: #ffffff;
    color: #1a1a1a;
    font-weight: 700;
    text-shadow: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);

    &:hover {
      color: #1a1a1a;
      background: #f0f0f0;
      transform: translateY(-1px);
    }
  }
}

/* ─── CATALOG GRID ────────────────────────────────────── */
.catalog-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
  align-items: stretch;   /* all cards same height */

  @media (max-width: 1200px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 576px)  { grid-template-columns: 1fr; }
}

.catalog-card {
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.18);
  height: 420px;           /* ← fixed height — all 4 cards equal */

  &__header { flex-shrink: 0; margin-bottom: 2px; }

  &__title {
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin: 0;
    opacity: 0.9;
  }
}

/* ─── IMAGE WRAPPER — contain, never crop ─────────────── */
.catalog-img-wrap {
  width: 100%;
  background: rgba(255,255,255,0.95);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex: 1;                  /* takes all available space in the item */

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;    /* never crop */
    padding: 8px;
    display: block;
  }

  /* single-item card — image fills card body */
  &--tall {
    flex: 1;
    img { height: 100%; }
  }

  /* wide bottom item in 3-grid */
  &--wide {
    img { height: 100%; }
  }
}

/* ─── INDIVIDUAL ITEM LINK ────────────────────────────── */
.catalog-item {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  border-radius: 10px;
  transition: transform 0.2s;
  /* each item takes equal share of the card's remaining height */
  flex: 1;
  min-height: 0;            /* allow flex children to shrink */

  &:hover { transform: translateY(-2px); text-decoration: none; }

  &--single {
    width: 100%;
    flex: 1;
  }
  &--wide { grid-column: span 2; }

  &__label {
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.35;
    margin: 0;
    padding: 5px 2px 2px;
    text-align: center;
    /* fixed label area — 2 lines max, ellipsis after that */
    flex-shrink: 0;
    height: 34px;            /* fits ~2 lines at 11px/1.35 */
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

/* ─── 2×2 GRID — fills card body evenly ──────────────── */
.catalog-grid-2x2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8px;
  flex: 1;
  min-height: 0;
}

/* ─── 2-TOP + 1-WIDE-BOTTOM GRID ─────────────────────── */
.catalog-grid-top2-bot1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8px;
  flex: 1;
  min-height: 0;
  .catalog-item--wide { grid-column: span 2; }
}

/* ─── DESKTOP FILTER BAR ──────────────────────────────── */
.desktop-filter-bar {
  padding: 0;
}

.filter-bar-inner {
  background: #fff;
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);
}

.filter-bar__breadcrumb {
  flex: 1 1 200px;
}

.filter-bar__controls {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.filter-control {
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }

  select, input {
    height: 36px;
    padding: 0 10px;
    font-size: 13px;
    border: 1px solid #dde1eb;
    border-radius: 8px;
    background: #f7f8fc;
    color: #333;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    min-width: 130px;
    &:focus {
      border-color: #4f6ef7;
      box-shadow: 0 0 0 3px rgba(79,110,247,0.12);
      background: #fff;
    }
  }

  &--range {
    flex-direction: row;
    align-items: flex-end;
    gap: 6px;
    input { min-width: 80px; }
  }
}

.range-sep {
  line-height: 36px;
  color: #aaa;
  font-size: 14px;
}

.apply-btn {
  height: 36px;
  padding: 0 16px;
  background: #4f6ef7;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #3a58e0; }
}

/* ─── MOBILE BOTTOM BUTTONS ───────────────────────────── */
.bottom-container {
  background: #fff;
  border-top: 1px solid #e8eaf0;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.07);
  position: fixed;
  bottom: 10vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 5vh;
  width: 100vw;
  z-index: 100;
}

.buttons {
  background: linear-gradient(135deg, #4f6ef7, #6c85fa);
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: opacity 0.2s;
  &:hover { opacity: 0.88; }
}

/* ─── MOBILE FILTER BAR — compact chip row ────────────── */
.mobile-filter-bar {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 2px;
  /* hide scrollbar but allow scroll if chips overflow */
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
}

/* Each filter chip: icon + native select */
.mf-chip {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: #fff;
  border: 1.5px solid #dde1eb;
  border-radius: 50px;
  padding: 0 10px 0 12px;
  height: 36px;
  flex-shrink: 0;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: #4f6ef7;
    box-shadow: 0 0 0 3px rgba(79,110,247,0.1);
  }

  &__label {
    font-size: 11px;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    white-space: nowrap;
    flex-shrink: 0;
    pointer-events: none;
    padding-right: 6px;
  }

  &__divider {
    width: 1px;
    height: 16px;
    background: #dde1eb;
    flex-shrink: 0;
    margin-right: 6px;
  }

  &__select {
    border: none;
    outline: none;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
    color: #2d3142;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    max-width: 90px;
    padding-right: 4px;
  }
}

/* Custom range row */
.mobile-custom-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mcr-input {
  flex: 1;
  height: 36px;
  padding: 0 10px;
  font-size: 13px;
  border: 1.5px solid #dde1eb;
  border-radius: 50px;
  background: #fff;
  outline: none;
  &:focus { border-color: #4f6ef7; }
}

.mcr-sep {
  color: #aaa;
  font-size: 14px;
  flex-shrink: 0;
}

/* ─── SIDEBAR ─────────────────────────────────────────── */
.sidebar {
  padding-right: 8px;
}

@media (max-width: 480px) {
  .filters-row { display: block !important; }
}
</style>